export default "__VITE_ASSET__3EH2RJS2__"